export default __webpack_public_path__ + "static/media/foodz@2x.804739c8.png";